<template>
	<div>
		<el-form :model="form" label-position="top" :rules="rules" ref="form">
			<el-form-item :label="innovatetable.displayname+(innovatetable.fieldtip?'('+innovatetable.fieldtip+')':'')||''" prop="innovate">
				<!-- <tinymce-editor v-model="form.innovate"></tinymce-editor> -->
				<Editor v-if="innovatetable.placecontent" v-model="form.innovate" :maxLength="innovatetable.len" :placeholder="innovatetable.placecontent || '请输入项目特色'"></Editor>
				<!-- <el-input type="textarea" maxlength="300" rows="6" show-word-limit placeholder="请输入项目简介" v-model="form.innovate">
        </el-input> -->
				<yincan :content="innovatetable.inputtip"></yincan>
				<!-- <div class="fz-FF0000">本项描述本项目与同类项目相比最具特色之处，该特色可以为专业的团队、更新颖的宣教形式与内容、更广泛的参与对象、更有影响力的产出、更科学的项目管理机制等；请选择1-2点具体描述，切勿泛泛而谈</div> -->
			</el-form-item>
			<el-form-item :label="activitytimetable.displayname+(activitytimetable.fieldtip?'('+activitytimetable.fieldtip+')':'')||''" prop="activitytime">
				<el-input v-model="form.activitytime" :placeholder="activitytimetable.placecontent||''" clearable></el-input>
				<yincan :content="activitytimetable.inputtip"></yincan>
				<!-- <div class="fz-FF0000">项目执行时间(含前期准备及线上工作)至项目结项时间,格式为xxxx年X月X日-xxxx年X月X日</div> -->
			</el-form-item>
			<el-form-item :label="activityweizi.displayname+(activityweizi.fieldtip?'('+activityweizi.fieldtip+')':'')||''" prop="activityaddress">
				<el-input v-model="form.activityaddress" :placeholder="activityweizi.placecontent||''" clearable></el-input>
				<yincan :content="activityweizi.inputtip"></yincan>
				<!-- <div class="fz-FF0000">拟定活动地点及原因(明确至具体城市、地点、学校、社区等)</div> -->
			</el-form-item>
			<el-form-item :label="activityobjecttable.displayname+(activityobjecttable.fieldtip?'('+activityobjecttable.fieldtip+')':'')||''" prop="activityobject">
				<el-input v-model="form.activityobject" :placeholder="activityobjecttable.placecontent||''" clearable></el-input>
				<yincan :content="activityobjecttable.inputtip"></yincan>
				<!-- <div class="fz-FF0000">活动面向群体(明确具体人群)</div> -->
			</el-form-item>
		</el-form>
		<bottomButtons @childrenDoPre="childrenDoPre" @childrenDoNext="childrenDoNext" />
		<!-- 地图弹框 start -->
		<el-dialog title="" :visible.sync="showMapDialog" @opened="opened" width="50%">
			<baseMap ref="map" @childrenSelectAddress="childrenSelectAddress" />
			<span slot="footer" class="dialog-footer">
				<el-button @click="showMapDialog = false">取 消</el-button>
				<el-button type="primary" @click="showMapDialog = false">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 体图弹框 end -->
	</div>
</template>
<script>
	import baseMap from "../../../components/baseMapDialog.vue";
	import bottomButtons from "../../../components/bottomButtons.vue";
	import TinymceEditor from "../../../components/tinymce-editor.vue";
	import Editor from "@/components/Editor.vue"
	import yincan from "../../../components/yincan.vue";
	import {
		saveProject,
		getProjectType
	} from "../../../api/signUp";
	import res from "../../../utils/msg";
	export default {
		components: {
			bottomButtons,
			baseMap,
			TinymceEditor,
			Editor,
			yincan
		},
		data() {
			return {
				typechoose: '',
				showMapDialog: false,
				form: {
					iscg: 1,
					project_id: "", // 项目 id
					school: "", // 学校名称
					team: "", // 团队
					name: "", // 项目名称
					project_type_id: "", // 项目类型
					teacher: "", // 指导老师
					teacherphone: "", // 老师联系方式
					dutyperson: "", // 项目负责人
					dutypersonphone: "", // 项目负责人联系方式
					address: "", // 通讯地址
					introduce: "", // 项目简介
					innovate: "", // 项目创新点
					activitytime: "", // 活动时间
					activityaddress: "", // 活动地点
					activityobject: "", // 活动对象
					step: "", // 步骤
					risk: "", // 项目风险
					target: "", // 预期目标
				},
				cinum: 1,
				rules: {
					innovate: [{
						required: true,
						message: "请输入项目特色",
						trigger: "blur"
					}, ],
					activitytime: [{
						required: true,
						message: "请输入活动时间",
						trigger: "blur"
					}, ],
					activityaddress: [{
						required: true,
						message: "请选择活动地点",
						trigger: "blur"
					}, ],
					activityobject: [{
						required: true,
						message: "请输入活动对象",
						trigger: "blur"
					}, ],
				},
				innovatetable:{},//项目特色
				activitytimetable:{},//活动时间
				activityweizi:{},//活动地点
				activityobjecttable:{},//活动对象
			};
		},
		mounted() {
			this.gettype()
			setTimeout(() => {
				this.getLable()
			}, 1500);
		},
		// watch: {
		// 	'form.innovate': {
		// 		handler(newval) {
		// 			if (this.cinum == 2) {
		// 				if (this.form.innovate.trim().length >= 300) {
		// 					res.error("最多只能输入300个字");
		// 				}
		// 			}else{
		// 					this.cinum = 2
		// 			}
		// 		},
		// 		deep: true,
		// 		immediate: true
		// 	}
		// },
		methods: {
			getLable(){
				this.innovatetable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'innovate')
				this.activitytimetable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'activitytime')
				this.activityweizi = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'activityweizi')
				this.activityobjecttable = this.$store.state?.hintText.hintText.data.find(item => item.fieldcode == 'activityobject')
			},
			gettype() {
				getProjectType().then(res => {
					this.typechoose = res.data.value
				})
			},
			getFather_step3(data) {
				this.form = data;
			},
			childrenDoPre() {
				this.$parent.doPre();
			},
			// 选择地图
			doAddress() {
				this.showMapDialog = true;
			},
			opened() {
				console.log(this.$refs.map);
				console.log(this.$refs["map"]);
				this.$refs.map.initMap();
			},
			childrenSelectAddress(e) {
				this.form.activityaddress = e;
			},
			childrenDoNext() {
				console.log(this.form.innovate);
				if (!this.form.innovate||this.form.innovate == '<p><br/></p>') {
					this.$message({
						message: '请输入'+this.innovatetable.displayname,
						type: 'warning'
					});
					return
				}
				const _this = this;
				_this.$refs.form.validate(async (valid) => {
					if (valid) {
						let _data = {
							...this.form,
							project_id: _this.form.project_id||_this.form.id,
						};
						// 把 project_type_id 转为逗号分隔的字符串
						if (this.typechoose == 1) {
							let newProjectTypeStrs = "";
							for (const v of _data.project_type_ids) {
								newProjectTypeStrs += v + ",";
							}
							newProjectTypeStrs = newProjectTypeStrs.substring(
								0,
								newProjectTypeStrs.length - 1
							);
							_data.project_type_ids = newProjectTypeStrs;
						}
						try {
							let saveRes = await saveProject(_data);
							if (saveRes.data.code === 1) {
								this.$message.success('更新成功');
								_this.$parent.doNext();
							} else {
								this.$message.error(saveRes.data.msg);
							}
						} catch (error) {
							console.log(error);
						}
					}
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.fz-FF0000 {
		color: #ff0000;
		font-size: 14px;
	}
</style>